import Vue from 'vue';
import App from './App.vue'; // Import your root component
new Vue({
  render: (h) => h(App),
}).$mount('#app');
// };
// getTranslation();
